import moment from 'moment';
import { useMemo } from 'react';

import { ScheduledLessonFilters } from '@/data/services/scheduledLessonsServices';
import { isTeacher } from '@/functions/auth';
import { KlassStatusEnum } from '@/models/Klass';
import User from '@/models/User';
import { getAuthorizedUnits } from '@/utils/getAuthorizedUnits';

export type YourLessonsTab = 'today' | 'nextLessons';

type UseYourLessonsFiltersProps = {
  user?: User;
  tab: YourLessonsTab;
};

export default function useYourLessonsFilters({
  user,
  tab,
}: UseYourLessonsFiltersProps) {
  const initialValues: Partial<ScheduledLessonFilters> = useMemo(
    () => ({
      teacher: isTeacher(user?.userType) ? user?.id : undefined,
      unit: getAuthorizedUnits(user),
      isActive: true,
      hasDone: false,
      ordering: 'datetime',
      klassStatus: [KlassStatusEnum.IN_PROGRESS, KlassStatusEnum.OPEN],
    }),
    [user],
  );

  const filter: Partial<ScheduledLessonFilters> = useMemo(
    () => ({
      ...initialValues,
      date: tab === 'today' ? moment().format('YYYY-MM-DD') : undefined,
      dateRangeAfter:
        tab === 'nextLessons' ? moment().add(1, 'day').format('YYYY-MM-DD') : undefined,
    }),
    [initialValues, tab],
  );

  return { filter };
}
